import Phaser from 'phaser';
import { SPARKLE_ANIMATION_KEY } from '../../gameData';

export default class HitParticle extends Phaser.GameObjects.Sprite {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene, 0,0,SPARKLE_ANIMATION_KEY, 0);

    this.vX = null;
    this.vY = null;
    this.vS = null;
    this.vA = null;
  }

  reset (x,y,startFrame) {
    this.x = x;
    this.y = y;
    this.alpha = 1;
    this.scale = 1;
    const speed = 1;
    const a = Math.PI * 2 * Math.random();
    const v = (Math.random() - 0.5) * 30 * speed;
    this.vX = Math.cos(a) * v;
    this.vY = Math.sin(a) * v;
    this.vS = (Math.random() - 0.5) * 0.2; // scale
    this.vA = -Math.random() * 0.05 - 0.01; // alpha

    this.setFrame(startFrame);
    this.play({
      key: 'sparkle',
      startFrame
    });
  }

  tick () {
    // apply gravity and friction
    this.vY += 0.5;
    this.vX *= 0.98;

    // update position, scale, and alpha:
    this.x += this.vX;
    this.y += this.vY;
    this.scale = this.scaleX + this.vS;
    this.alpha += this.vA;
  }
}